import React, { useState } from 'react'
import { BrowserView, isMobile, MobileView } from 'react-device-detect'
import { useParams } from 'react-router-dom'
import { faQuestion } from '@fortawesome/free-solid-svg-icons'

import {
  $DCprimaryColor,
  DcButton,
  DcDropDown,
  DcInput,
  PixelBreadcrumbs,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  PixelPageContainer,
  PixelText,
  PixelTopBar,
  Section,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'
import { createCourier, get } from 'utils/api-routes.util'
import SaveIcon from 'utils/icons/save-icon'
import { IPixelFactory } from '../../../../../../decl.d'

const AddCourier = (props) => {
  const [couriersCompanies, setCouriersCompanies] = React.useState([])
  const [courierTypes, setCourierTypes] = React.useState([])
  const [activeCompany, setActiveCompany] = React.useState<any>(null)
  const [fields, setFields] = React.useState([])
  const { readApi, setCourierId } = props
  const { showSuccess, showFailure, showLoader, hideLoader, pixelConfirm } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const param = useParams()
  const courierId = param.id

  const [data, setData] = useState({
    courier_name: '',
    payment_gateway_id: '',
    access_type: 1,
    prefix: '',
    startnumber: '',
    endnumber: '',
    origin_city: '',
  })

  const courierRef = React.useRef(null)
  const getAllCourierTypes = () => {
    get('/settings/couriers/types').subscribe((res: any) => {
      if (res.response?.data) {
        setCourierTypes(res.response.data)
      }
    })
  }

  const getCourierDetails = (id, companies) => {
    showLoader(courierRef)
    get(`/settings/couriers/${id}`).subscribe((res: any) => {
      const courier = res.response
      setData(courier)
      const company = companies.find(
        (company: any) => company.id == courier.company_id,
      )
      setActiveCompany(company)
      setFields(company.schema.types['api'])
      hideLoader(courierRef)
    })
  }

  const getAllCourierCompanies = () => {
    showLoader(courierRef)
    get('/settings/couriers/companies').subscribe((res: any) => {
      const companies = res.response.data
        .map((c) => {
          c['slug'] = c.name.replace(/\s+/g, '-').toLowerCase()
          return c
        })
        .filter((c) => {
          return !!c.schema
        })
      setCouriersCompanies(companies)
      if (courierId) {
        getCourierDetails(courierId, companies)
      }
      hideLoader(courierRef)
    })
  }
  React.useEffect(() => {
    getAllCourierCompanies()
    getAllCourierTypes()
  }, [])
  const handleClick = (company, isDirect = false) => {
    if (courierId) return
    if (isDirect) {
      setActiveCompany(company)
      setFields(company.schema.types['api'])
      return
    }
    if (checkData()) {
      isConfirm(company)
    } else {
      setActiveCompany(company)
      setFields(company.schema.types['api'])
    }
  }

  const checkData = () => {
    if (!activeCompany) return false
    const dataKeys = Object.keys(data)

    delete dataKeys.payment_gateway_id
    const isChanged = dataKeys.some((key) => {
      return data[key] !== ''
    })
    return isChanged
  }

  const emptyData = () => {
    //   reset value to empty string
    const dataKeys = Object.keys(data)
    dataKeys.forEach((key) => {
      setData({ ...data, [key]: '' })
    })
  }

  const isConfirm = (company) => {
    pixelConfirm({
      title: 'Are you sure you want to switch?',
      message: 'You have unsaved changes.',
      onConfirm: () => {
        emptyData()
        setActiveCompany(company)
        setFields(company.schema.types['api'])
      },
    })
    return false
  }

  const getTypeName = (id) => {
    const type = courierTypes.find((t) => {
      return t.courier_type_id == id
    })
    return type ? type.courier_type : 'api'
  }

  const create = () => {
    showLoader(courierRef)
    const postData: any = data
    postData.company_id = activeCompany.id
    if (activeCompany.name === 'Pakistan Post' && data.access_type == 4) {
      postData['series'] = {
        prefix: data.prefix,
        start: data.startnumber,
        end: data.endnumber,
      }
    }
    createCourier(postData).subscribe((res: any) => {
      hideLoader(courierRef)
      if (res.response && res.response.courier_id) {
        emptyData()
        showSuccess('Successfully Added')
        setCourierId(res.response.courier_id)
        readApi()
        // navigate(`/admin/couriers/details/${res.response.courier_id}`)
      } else if (res && res.response['error']) {
        if (res.response['field']) {
          setError({
            error: res.response['error'],
            field: res.response['field'],
          })
        } else {
          showFailure(res.response['error'])
        }
      }
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    create()
  }

  const getCompanyByID = (id) => {
    const company = couriersCompanies.find((c) => {
      return c.id == id
    })
    return company
  }

  return (
    <>
      <PixelPageContainer>
        <Section isMobile={isMobile} style={{ padding: '0px' }}>
          <SectionContent ref={courierRef} className="courier">
            <BrowserView>
              <PixelFlexBox
                padding="10px 0"
                gap="10px"
                flexWrap="wrap"
                justifyContent="flex-start"
                alignItems="center"
                alignContent="flex-start"
              >
                {couriersCompanies.map((company: any, i: number) => (
                  <FilterButton
                    key={i}
                    className={
                      activeCompany === company
                        ? 'active'
                        : courierId
                        ? 'disabled'
                        : ''
                    }
                    onClick={() => handleClick(company)}
                  >
                    <img src={company.image_path} /> {company.name}
                  </FilterButton>
                ))}
              </PixelFlexBox>
            </BrowserView>
            <MobileView>
              <DcDropDown
                style={{ marginBottom: '15px' }}
                options={couriersCompanies.map((option) => {
                  return {
                    label: option.name,
                    value: option.id,
                  }
                })}
                placeholder={'Select Courier'}
                required
                value={activeCompany?.id}
                onChange={(e) => {
                  handleClick(getCompanyByID(e.target.value))
                }}
              />
            </MobileView>
            {activeCompany && (
              <PixelFlexBox flexDirection="column" gap="10px">
                <form onSubmit={handleSubmit}>
                  <PixelText
                    customColor="#878c90"
                    textSize="18px"
                    style={{
                      marginTop: '1rem',
                      fontWeight: '500',
                      letterSpacing: '0.6px',
                    }}
                  >
                    Basic Information
                  </PixelText>
                  <PixelFlexBox
                    flexDirection="row"
                    flexWrap="wrap"
                    style={{
                      flexDirection: isMobile && 'column',
                      width: '100%',
                      flexGrow: '1',
                      gap: '10px',
                    }}
                    isMobile={isMobile}
                  >
                    <DcInput
                      tabIndex={1}
                      error={
                        error.field === 'courier_name' && error.error !== ''
                          ? error.error
                          : null
                      }
                      required
                      type={'text'}
                      name={'Account Name'}
                      placeholder={'Account Name'}
                      value={data.courier_name}
                      onChange={(e) =>
                        setData({ ...data, courier_name: e.target.value })
                      }
                    />
                    {/* <PixelFlexBox gap="10px">
                      <DcDropDown
                        tabIndex={2}
                        error={
                          error.field === 'payment_gateway_id' &&
                          error.error !== ''
                            ? error.error
                            : null
                        }
                        required
                        placeholder={'Select Payment gateway'}
                        options={[
                          {
                            title: 'Select Payment gateway',
                            id: '',
                          },
                          ...paymentGateways,
                        ].map((p) => {
                          return {
                            label: p.title,
                            value: p.id,
                          }
                        })}
                        value={data.payment_gateway_id}
                        onChange={(e) => {
                          setData({
                            ...data,
                            payment_gateway_id: e.target.value,
                          })
                        }}
                      />
                      <DcButton
                        tabIndex={3}
                        style={{ maxWidth: '50px' }}
                        onClick={() => setShowNewModal(true)}
                      >
                      </DcButton>
                    </PixelFlexBox> */}
                  </PixelFlexBox>
                  <PixelText
                    customColor="#878c90"
                    textSize="18px"
                    style={{
                      fontWeight: '500',
                      letterSpacing: '0.6px',
                      padding: '5px 0',
                    }}
                  >
                    API Configuration
                    <a
                      style={{ color: '#fff' }}
                      href={activeCompany?.doc_path}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <PixelIcon
                        showTooltip="true"
                        tooltip="How to get the API Key?"
                        icon={faQuestion}
                      />
                    </a>
                  </PixelText>

                  <PixelFlexBox
                    flexDirection="row"
                    flexWrap="wrap"
                    style={{
                      flexDirection: isMobile && 'column',
                      width: '100%',
                      flexGrow: '1',
                      gap: '10px',
                    }}
                    isMobile={isMobile}
                  >
                    <DcDropDown
                      tabIndex={4}
                      error={
                        error.field === 'access_type' && error.error !== ''
                          ? error.error
                          : null
                      }
                      required
                      placeholder={'Select Tracking/Access Type'}
                      options={courierTypes.map((p: any) => {
                        return {
                          label: p.courier_type,
                          value: p.courier_type_id,
                          disabled:
                            activeCompany?.schema?.disallowed_types.indexOf(
                              p.courier_type,
                            ) !== -1,
                        }
                      })}
                      value={data.access_type}
                      onChange={(e) => {
                        setFields(
                          activeCompany.schema.types[
                            getTypeName(e.target.value)
                          ],
                        )
                        setData({ ...data, access_type: e.target.value })
                      }}
                    />
                    {fields.map((field) => {
                      return (
                        <DcInput
                          tabIndex={5}
                          key={field.field_name}
                          error={
                            error.field === field.field && error.error !== ''
                              ? error.error
                              : null
                          }
                          type={field.type}
                          name={field.field}
                          required
                          placeholder={field.field_name}
                          value={data[field.field]}
                          onChange={(e) =>
                            setData({ ...data, [field.field]: e.target.value })
                          }
                        />
                      )
                    })}
                  </PixelFlexBox>
                  <PixelFlexBox
                    flexDirection="row"
                    flexWrap="wrap"
                    style={{
                      flexDirection: isMobile && 'column',
                      width: '100%',
                      flexGrow: '1',
                      gap: '10px',
                    }}
                  >
                    <DcButton
                      size="sm"
                      tabIndex={6}
                      variant="primary"
                      type={'submit'}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '5px',

                        marginTop: '50px',
                      }}
                    >
                      <SaveIcon size={16} /> Save
                    </DcButton>
                  </PixelFlexBox>
                </form>
              </PixelFlexBox>
            )}
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

const FilterButton = styled.button`
  background-color: #f7f7f8;
  border: none;
  border-radius: 5px;
  padding: 7px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #878c90;
  cursor: pointer;
  border-right: none;
  text-transform: capitalize;
  letter-spacing: 0.6px;

  &:hover,
  &.active {
    background-color: ${$DCprimaryColor};
    border-color: ${$DCprimaryColor};
    color: #fff;
  }
  &.disabled {
    background-color: #ccccd1;
    border-color: #ccccd1;
    color: #878c90;
    cursor: not-allowed;
    opacity: 0.8;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    border-radius: 50%;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  }
`
export default AddCourier
